var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
import ArrowDownIcon from "../../common/images/arrow-down-white.svg";
var RTLShows = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLShows, _LitElement);
  function RTLShows() {
    var _this;
    _classCallCheck(this, RTLShows);
    _this = _callSuper(this, RTLShows);
    _this.theme = 'dark';
    _this.media = 'tele';
    return _this;
  }
  _createClass(RTLShows, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLShows.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      //TODO: api url
      if (this.media == 'radio') {
        this._apiUrl = `https://www.rtl.lu/api/replay/radio/shows`;
      } else {
        this._apiUrl = `https://www.rtl.lu/api/replay/tele/shows`;
      }
      fetch(this._apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      });
    }
  }, {
    key: "_goToShow",
    value: function _goToShow(e) {
      if (e.target.value) {
        document.location.href = e.target.value;
      }
    }
  }, {
    key: "_renderTele",
    value: function _renderTele() {
      var _this3 = this;
      return html(_t || (_t = _`
            <select class="rtl-shows-select" style="background-image: url('${0}');" @change=${0}>
                <option class="rtl-shows-select__item">Emissioun auswielen</option>
                <optgroup class="rtl-shows-select__group" label="Highlights">
                    ${0}
                </optgroup>
                <optgroup class="rtl-shows-select__group" label="Emissiounen vun A-Z">
                    ${0}
                </optgroup>
            </select>
        `), ArrowDownIcon, function (e) {
        return _this3._goToShow(e);
      }, this.data.highlights.map(function (highlight) {
        return html(_t2 || (_t2 = _`
                        <option class="rtl-shows-select__item" value="${0}">${0}</option>
                    `), highlight.link, highlight.name);
      }), this.data.shows.map(function (show) {
        return html(_t3 || (_t3 = _`
                        <option  class="rtl-shows-select__item" value="${0}">${0}</option>
                    `), show.link, show.name);
      }));
    }
  }, {
    key: "_renderRadio",
    value: function _renderRadio() {
      var _this4 = this;
      return html(_t4 || (_t4 = _`
            <select class="rtl-shows-select" style="background-image: url('${0}');" @change=${0}>
                <option class="rtl-shows-select__item">Emissioun auswielen</option>
                    ${0}
            </select>
        `), ArrowDownIcon, function (e) {
        return _this4._goToShow(e);
      }, this.data.shows.map(function (show) {
        return html(_t5 || (_t5 = _`
                        <option  class="rtl-shows-select__item" value="${0}">${0}</option>
                    `), show.link, show.name);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data == undefined) return html(_t6 || (_t6 = _`Loading...`));
      return html(_t7 || (_t7 = _`
            <style>${0}</style>
            <div class="rtl-shows rtl-shows--${0}">
                ${0}
            </div>
        `), css, this.theme, this.media == 'radio' ? this._renderRadio() : this._renderTele());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        theme: {
          type: String
        },
        media: {
          type: String
        }
      };
    }
  }]);
  return RTLShows;
}(LitElement);
export { RTLShows as default };
window.customElements.define('rtl-shows', RTLShows);